import localeAntd from 'antd/es/locale/th_TH'

const messages = {
  'topBar.issuesHistory': 'ประวัติ',
  'topBar.typeToSearch': 'พิมพ์เพิ่มค้นหา...',
  'topBar.actions': 'Actions',
  'topBar.status': 'Status',
  'topBar.profileMenu.hello': 'สวัสดี',
  'topBar.profileMenu.billingPlan': 'แผนการจ่ายเงิน',
  'topBar.profileMenu.role': 'บทบาท',
  'topBar.profileMenu.email': 'อีเมล',
  'topBar.profileMenu.phone': 'เบอร์โทร',
  'topBar.profileMenu.editProfile': 'แก้ไขข้อมูลส่วนตัว',
  'topBar.profileMenu.logout': 'ออกจากระบบ',
}

export default {
  locale: 'th-TH',
  localeAntd,
  messages,
}
